import { Plate } from '@/components/landing/primitives';
import { stagger } from '@/components/landing/stagger';
import { FAQ, faqJsonLd } from '@/content/faq';

// `<` escaped so no answer can ever close the script element early.
const JSON_LD = JSON.stringify(faqJsonLd()).replace(/</g, '\\u003c');

/** The heading holds its place on the left while the answers scroll past on
 *  the right. Every answer is always open: a closed accordion is content a
 *  visitor has to ask for, and five short answers fit on one screen anyway. */
export function FaqSection() {
  return (
    <Plate eyebrow="FAQ" id="faq" labelledBy="faq-title">
      <div className="grid gap-12 lg:grid-cols-[5fr_7fr] lg:gap-16">
        <div>
          <h2 id="faq-title" className="lp-h2 lp-reveal lg:sticky lg:top-28" style={stagger(1)}>
            Questions we hear often
          </h2>
        </div>
        <dl className="border-b border-border">
          {FAQ.map((f, i) => (
            <div key={f.q} className="lp-reveal border-t border-border py-8" style={stagger(2 + i)}>
              <dt className="t-h3">{f.q}</dt>
              <dd className="mt-3 text-[17px] leading-relaxed text-[hsl(var(--fg-secondary))]">{f.a}</dd>
            </div>
          ))}
        </dl>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON_LD }} />
    </Plate>
  );
}
